import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleFormatService } from 'src/core/services';
import { LanguageStore } from 'src/core/stores';

@Pipe({
  name: 'localePercent',
  standalone: true,
  pure: false,
})
export class LocalePercentPipe implements PipeTransform {
  private readonly localeFormatService = inject(LocaleFormatService);
  private readonly languageStore = inject(LanguageStore);

  transform(
    value: number | null | undefined,
    percentFormatOptions: Omit<Intl.NumberFormatOptions, 'style'> = {},
  ): string {
    void this.languageStore.locale();
    return this.localeFormatService.formatPercent(value, percentFormatOptions);
  }
}
